<template>
  <app-types-checkbox :label="$t('EQUIPMENT_TYPES_CHECKBOX.TITLE')"
                      :types="equipmentTypes"
                      :value="value"
                      @input="emit"
                      v-loading="isLoading">
  </app-types-checkbox>
</template>

<script>
import facetsService from '@/services/facetsService'
import AppTypesCheckbox from '../types-checkbox/TypesCheckbox'

export default {
  name: 'AppEquipmentTypesCheckbox',
  components: { AppTypesCheckbox },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isLoading: false,
      equipmentTypes: []
    }
  },
  created () {
    this.getEquipmentTypes()
  },
  methods: {
    async getEquipmentTypes () {
      this.isLoading = true

      try {
        this.equipmentTypes = await facetsService.findAllEquipmentTypes()
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        throw error
      }
    },
    emit (value) {
      this.$emit('input', value)
    }
  }
}
</script>
